import { localStorageTokenKey } from '../hooks';
import { parseJwt } from './strings';
export var getUserId = function () {
    var token = localStorage.getItem(localStorageTokenKey) || '';
    var parsedJwt = parseJwt(token || '');
    return (parsedJwt === null || parsedJwt === void 0 ? void 0 : parsedJwt.sub) || '';
};
